import { makeDimensionUpdateBack, makeDimensionUpdateFront, makeDimensionUpdateRight, makeDimensionUpdateLeft } from "./leanBuilding.helper";
import { getGaugeRoofCost } from "../building_pricing/buildingPricing.helper";
import { handlCupolaPositionOnDimensionChange } from "../building_component/buildingComponent.helper";

export const calculateLeanBasicPrice = ({ baseData = [], gaugeValue, p_r_s, UpdatePriceRecord, priceChangedFlag, leanData = {}, currentTotal = 0 }) => {
	let basic_price = 0;

	if (!Array.isArray(baseData) || baseData.length === 0) {
		return {
			basic_price: 0,
			total: currentTotal,
			roofBasePrice: 0
		};
	}
	const cost = getGaugeRoofCost(baseData, p_r_s, gaugeValue);
	basic_price = UpdatePriceRecord === true && priceChangedFlag !== true ? leanData?.basic_price || 0 : cost || 0;

	const updatedTotal = parseFloat(currentTotal) + parseFloat(basic_price);

	return {
		basic_price,
		total: updatedTotal,
		roofBasePrice: basic_price
	};
};
export const handleAddLeantoSection = (state, action, utils, const_var, params, cuBuilding, cuComponent, dynamicWallOptions, dynamicWallOptionsForLeanTo) => {
	let roofPitchForLean = "2/12";
	const leanToIds = state.const_var.Map_Id[state.params.p_b_t] ?? [];
	let defaultLeanToData = const_var.building?.find((data) => data.building_type.building_id === leanToIds);
	utils.update26GAUpgradePrice();
	if (defaultLeanToData != undefined && defaultLeanToData.lean_to_roof_pitch != undefined) {
		let roofPitchData = defaultLeanToData.lean_to_roof_pitch.find((data) => data.is_default == "yes");
		roofPitchForLean = roofPitchData != undefined ? roofPitchData.roof_pitch : roofPitchForLean;
	}

	let defaultLeanToRoofPitch = 2;

	let UpdateAction = "";
	let LeanFlag = false;
	var chkEndJtrim = false;
	var chkSideJtrim = false;
	if (const_var.a_p_d_a?.jtrim?.length > 0) {
		chkEndJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "end").length > 0 ? true : false;
		chkSideJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "side").length > 0 ? true : false;
	}
	if (action.value == "endLeantosForTubulerBuildingMnf") {
		const_var.isShowAlert = true;
		const_var.alertUsedFor = "endLeantosForTubulerBuildingMnf";
		return {
			...state,
			action
		};
	}

	let buildingName = const_var.defaultBuildingArr[const_var.BuldingIDforReset] && const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name?.split(".")?.includes("Straight_Roof_Barns");

	let checkType =
		params.m_s_n == 3 &&
		buildingName &&
		((const_var.editAPIDataByResponse.data?.main_created_at >= "2024-07-01" && (const_var.crmSetting.is_Edit == true || const_var.isKLinkEnable == true)) ||
			const_var.loginSession == false ||
			const_var.loginSession == true)
			? true
			: false;

	let leanDrawingCost = 0;
	if (const_var.order_extra_items.engineer_drawings_name != undefined && const_var.order_extra_items.engineer_drawings_name.toLowerCase() != "none") {
		let leanToDrawing = const_var.c_m_a[const_var.c_m_a[params.p_b_t].default_lean_id];
		leanToDrawing = leanToDrawing?.drawings;
		let selLeanDrawingObj =
			leanToDrawing != undefined && leanToDrawing.length != 0 ? leanToDrawing.find((obj) => const_var.order_extra_items.engineer_drawings_name.toLowerCase() == obj.name.toLowerCase()) : undefined;
		leanDrawingCost = selLeanDrawingObj != undefined ? selLeanDrawingObj.cost : 0;
	}
	let gableLeanWidthLR = 12;
	let gableLeanWidthFB = 12;
	if (gableLeanWidthLR > params.p_d && const_var.c_m_a?.[params.p_b_t]?.gable_mapping?.length > 0) {
		gableLeanWidthLR = state.const_var.c_m_a[state.params.p_b_t].gable_mapping[0].min_width;
	}
	if (gableLeanWidthFB > params.p_w && const_var.c_m_a?.[params.p_b_t]?.gable_mapping?.length > 0) {
		gableLeanWidthFB = state.const_var.c_m_a[state.params.p_b_t].gable_mapping[0].min_width;
	}
	let gableLeanLength = 20;
	if (
		const_var.c_m_a?.[params.p_b_t]?.gable_mapping?.length > 0 &&
		!(gableLeanLength > state.const_var.c_m_a[state.params.p_b_t].gable_mapping[0].min_length && state.const_var.c_m_a[state.params.p_b_t].gable_mapping[0].max_length >= gableLeanLength)
	) {
		gableLeanLength = state.const_var.c_m_a[state.params.p_b_t].gable_mapping[0].min_length;
	}

	if (action.value == "addFrontLean") {
		state.params.leanF_p_pos = 0;
		state.params.add_front_lean = !state.params.add_front_lean;
		if (
			state.params.add_front_lean == false &&
			(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
			(params.p_f_w.toLowerCase() == "one_fourth_close" || params.p_f_w.toLowerCase() == "three_fourth_close" || params.p_f_w.toLowerCase() == "half_close")
		) {
			params.p_f_w = "Open";
		}
		if (state.params.add_front_lean == true) {
			params.p_f_b_l = false;
			if (params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160) {
				const_var.isCheckGroundCertificate = true;
			}
		} else {
			if (action.from !== "changeStyle") {
				params.leanStyle.front = "standard";
			}

			params.p_f_b_l = true;
			params.add_storage_check_front = false;
			const_var.leanFHasDoublelegshow = params.leanF_p_e_l = false;
			params.insulation.frontLean = { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false };
			const_var.isCheckGroundCertificate = false;
		}

		params.isShowCenter = false;
		const_var.llsh = false;
		const_var.rlsh = false;
		const_var.flsh = false;
		const_var.blsh = false;
		state.params.b_l_t_r_pF = defaultLeanToRoofPitch;
		state.params.b_f_l_t_f = "Open";
		state.params.b_f_l_t_r = "Open";
		state.params.b_f_l_t_l = "Open";
		if (action.from !== "changeStyle") {
			state.params.p_b_c_b_f_f = "Open";
			state.params.p_b_c_b_f_b = "Open";
			state.params.p_b_c_b_f_l = "Open";
			state.params.p_b_c_b_f_r = "Open";
		}
		state.params.leantoAlignmentFront = "1";

		const_var.checkforLeanto = state.params.add_front_lean == true ? true : false;
		state.params.leanF_p_d = params.leanStyle.front == "gable" ? gableLeanLength : state.params.p_w;
		state.params.leanF_p_w = params.leanStyle.front == "gable" ? gableLeanWidthFB : 12;
		params.leanF_p_h = state.const_var.b_m_i_hlean > params.leanF_p_h ? state.const_var.b_m_i_hlean : params.leanF_p_h;
		const_var.lengthData.frontLean.length = state.params.leanF_p_d;
		state.isFullyEnclosedCheckedForFrontLeanTo = false;
		state.isFullyOpenedCheckedForFrontLeanTo = true;
		UpdateAction = action.event + action.value + state.params.add_front_lean;

		if (state.params.add_front_lean == false) {
			state.params.add_left_front_lean_porch = false;
			state.params.add_right_front_lean_porch = false;
		}

		let straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, params.b_l_t_r_pF, const_var.roofRegularDst);

		var calHeight = state.params.leanF_p_h + Math.round((state.params.leanF_p_w * state.params.b_l_t_r_pF) / 12) + straightRoofval;
		let frontLeanRoofHeight = calHeight;

		let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height;
		if (
			const_var.isForStandardBuilding == true &&
			!const_var.b_o_J_1[params.p_b_t].includes("Free Standing") &&
			!const_var.b_o_J_1[params.p_b_t].includes("RV Covers") &&
			params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height
		) {
			isMaxHeight = params.p_w;
		}

		if (calHeight > state.params.p_h && calHeight <= isMaxHeight) {
			state.params.p_h = params.p_h <= frontLeanRoofHeight ? frontLeanRoofHeight : state.params.p_h;
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.UpdatedPriceData.right_wall_price_changed = true;
			const_var.UpdatedPriceData.left_wall_price_changed = true;
			const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
			const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
			const_var.UpdatedPriceData.front_wall_price_changed = true;
			const_var.UpdatedPriceData.back_wall_price_changed = true;
			const_var.UpdatedPriceData.utility_price_changed = true;
			const_var.UpdatedPriceData.common_height_changed = true;
			if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
			const_var.UpdatedPriceData.right_lean_height_price_changed = true;
			const_var.UpdatedPriceData.left_lean_height_price_changed = true;
			const_var.UpdatedPriceData.back_lean_height_price_changed = true;
		}

		cuBuilding.UpdateFrontLean();
		makeDimensionUpdateFront(state);
		if (params.p_f_w != "Open" && params.p_f_w != "Close" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		if (cuComponent.wallnameBySec[params.activeWall] === "frontlean" && !params.add_front_lean) params.activeWall = "c_b_f_w";
	}
	if (action.value == "addBackLean") {
		state.params.leanB_p_pos = 0;
		state.params.add_back_lean = !state.params.add_back_lean;
		if (state.params.add_back_lean == true) {
			params.p_b_b_l = false;
			if (params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160) {
				const_var.isCheckGroundCertificate = true;
			}
		} else {
			if (action.from !== "changeStyle") {
				params.leanStyle.back = "standard";
			}

			params.p_b_b_l = true;
			params.add_storage_check_back = false;
			const_var.leanBHasDoublelegshow = params.leanB_p_e_l = false;
			params.insulation.backLean = { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false };
			const_var.isCheckGroundCertificate = false;
		}
		if (
			state.params.add_back_lean == false &&
			(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
			(params.p_b_w.toLowerCase() == "one_fourth_close" || params.p_b_w.toLowerCase() == "three_fourth_close" || params.p_b_w.toLowerCase() == "half_close")
		) {
			params.p_b_w = "Open";
		}

		params.isShowCenter = false;
		const_var.llsh = false;
		const_var.rlsh = false;
		const_var.flsh = false;
		const_var.blsh = false;
		state.params.b_l_t_r_pB = defaultLeanToRoofPitch;
		state.params.b_b_l_t_f = "Open";
		state.params.b_b_l_t_r = "Open";
		state.params.b_b_l_t_l = "Open";
		if (action.from !== "changeStyle") {
			state.params.p_b_c_b_b_f = "Open";
			state.params.p_b_c_b_b_b = "Open";
			state.params.p_b_c_b_b_l = "Open";
			state.params.p_b_c_b_b_r = "Open";
		}
		state.params.leantoAlignmentBack = "1";

		state.params.leanB_p_d = params.leanStyle.back == "gable" ? gableLeanLength : state.params.p_w;
		state.params.leanB_p_w = params.leanStyle.back == "gable" ? gableLeanWidthFB : 12;
		params.leanB_p_h = state.const_var.b_m_i_hlean > params.leanB_p_h ? state.const_var.b_m_i_hlean : params.leanB_p_h;
		const_var.lengthData.backLean.length = state.params.leanB_p_d;
		state.isFullyEnclosedCheckedForBackLeanTo = false;
		state.isFullyOpenedCheckedForBackLeanTo = true;
		UpdateAction = action.event + action.value + state.params.add_back_lean;
		const_var.checkforLeanto = state.params.add_back_lean == true ? true : false;
		if (state.params.add_back_lean == false) {
			state.params.add_left_back_lean_porch = false;
			state.params.add_right_back_lean_porch = false;
		}

		let straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, params.b_l_t_r_pB, const_var.roofRegularDst);
		var calHeight = state.params.leanB_p_h + Math.round((state.params.leanB_p_w * state.params.b_l_t_r_pB) / 12) + straightRoofval;
		let backLeanRoofHeight = calHeight;

		let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height;
		if (
			const_var.isForStandardBuilding == true &&
			!const_var.b_o_J_1[params.p_b_t].includes("Free Standing") &&
			!const_var.b_o_J_1[params.p_b_t].includes("RV Covers") &&
			params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height
		) {
			isMaxHeight = params.p_w;
		}

		if (state.params.add_back_lean == true && calHeight > state.params.p_h && calHeight <= isMaxHeight) {
			state.params.p_h = params.p_h < backLeanRoofHeight ? backLeanRoofHeight : state.params.p_h;
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.UpdatedPriceData.right_wall_price_changed = true;
			const_var.UpdatedPriceData.left_wall_price_changed = true;
			const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
			const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
			const_var.UpdatedPriceData.front_wall_price_changed = true;
			const_var.UpdatedPriceData.back_wall_price_changed = true;
			const_var.UpdatedPriceData.utility_price_changed = true;
			const_var.UpdatedPriceData.common_height_changed = true;
			const_var.UpdatedPriceData.right_lean_height_price_changed = true;
			const_var.UpdatedPriceData.left_lean_height_price_changed = true;
			const_var.UpdatedPriceData.front_lean_height_price_changed = true;
			if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
		}

		cuBuilding.UpdateBackLean();
		makeDimensionUpdateBack(state);
		if (params.p_b_w != "Open" && params.p_b_w != "Close" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		if (cuComponent.wallnameBySec[params.activeWall] === "backlean" && !params.add_back_lean) params.activeWall = "c_b_b_w";
	}
	if (action.value == "addLeftLean") {
		state.params.lean_p_pos = 0;
		state.params.add_left_lean = !state.params.add_left_lean;
		if (!state.params.add_left_lean) {
			const_var.isStraightRoofL = true;
			if (action.from !== "changeStyle") {
				params.leanStyle.left = "standard";
			}
		}
		if (state.params.add_left_lean == true) {
			params.p_l_b_l = false;
			if (params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160) {
				const_var.isCheckGroundCertificate = true;
			}
		} else {
			params.p_l_b_l = true;
			params.add_storage_check = false;
			const_var.leanHasDoublelegshow = params.lean_p_e_l = false;
			params.insulation.leftLean = { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false };
			const_var.isCheckGroundCertificate = false;
		}

		params.isShowCenter = false;
		const_var.llsh = false;
		const_var.rlsh = false;
		const_var.flsh = false;
		const_var.blsh = false;
		state.params.b_l_t_r_p = checkType ? "3" : defaultLeanToRoofPitch;
		state.params.b_l_l_t_f = "Open";
		state.params.b_l_l_t_b = "Open";
		state.params.b_l_l_t_l = "Open";
		state.params.b_l_l_t_r = "Open";
		if (action.from !== "changeStyle") {
			state.params.p_b_c_b_l_f = "Open";
			state.params.p_b_c_b_l_b = "Open";
			state.params.p_b_c_b_l = "Open";
			state.params.p_b_c_b_l_r = "Open";
		}

		state.params.lean_p_w = params.leanStyle.left == "gable" ? gableLeanWidthLR : 12;
		state.params.lean_p_d = params.leanStyle.left == "gable" ? gableLeanLength : state.params.p_d;
		params.lean_p_h = state.const_var.b_m_i_hlean > params.lean_p_h ? state.const_var.b_m_i_hlean : params.lean_p_h;
		const_var.lengthData.leftLean.length = state.params.lean_p_d;
		params.leantoAlignmentLeft = "1";
		UpdateAction = action.event + action.value + state.params.add_left_lean;
		const_var.checkforLeanto = state.params.add_left_lean == true ? true : false;

		if (state.params.add_left_lean == false) {
			state.params.add_left_front_lean_porch = false;
			state.params.add_left_back_lean_porch = false;
		}

		state.isFullyEnclosedCheckedForLeftLeanTo = false;
		state.isFullyOpenedCheckedForLeftLeanTo = true;

		let straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, state.params.b_l_t_r_p, const_var.roofRegularDst);

		var calHeight = state.params.lean_p_h + Math.round((state.params.lean_p_w * state.params.b_l_t_r_p) / 12) + straightRoofval;
		let leftLeanRoofHeight = calHeight;

		let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height;
		if (
			const_var.isForStandardBuilding == true &&
			!const_var.b_o_J_1[params.p_b_t].includes("Free Standing") &&
			!const_var.b_o_J_1[params.p_b_t].includes("RV Covers") &&
			params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height
		) {
			isMaxHeight = params.p_w;
		}

		if (state.params.add_left_lean == true && calHeight > state.params.p_h && calHeight <= isMaxHeight) {
			state.params.p_h = params.p_h < leftLeanRoofHeight ? leftLeanRoofHeight : state.params.p_h;
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.UpdatedPriceData.right_wall_price_changed = true;
			const_var.UpdatedPriceData.left_wall_price_changed = true;
			const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
			const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
			const_var.UpdatedPriceData.front_wall_price_changed = true;
			const_var.UpdatedPriceData.back_wall_price_changed = true;
			const_var.UpdatedPriceData.utility_price_changed = true;
			const_var.UpdatedPriceData.common_height_changed = true;
			const_var.UpdatedPriceData.right_lean_height_price_changed = true;
			const_var.UpdatedPriceData.back_lean_height_price_changed = true;
			const_var.UpdatedPriceData.front_lean_height_price_changed = true;
			if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
		}

		cuBuilding.UpdateLeftLean();
		makeDimensionUpdateLeft(state);
		if (params.p_l_w != "Open" && params.p_l_w != "Close" && chkSideJtrim == true) {
			params.p_j_t = true;
		}

		if (cuComponent.wallnameBySec[params.activeWall] === "leftlean" && !params.add_left_lean) params.activeWall = "c_b_l_w";
	}
	if (action.value == "addRightLean") {
		state.params.leanR_p_pos = 0;
		state.params.add_right_lean = !state.params.add_right_lean;
		if (!state.params.add_right_lean) {
			const_var.isStraightRoofR = true;
			if (action.from !== "changeStyle") {
				state.params.leanStyle.right = "standard";
			}
		}
		if (state.params.add_right_lean == true) {
			params.p_r_b_l = false;
			if (params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160) {
				const_var.isCheckGroundCertificate = true;
			}
		} else {
			params.p_r_b_l = true;
			params.add_storage_check_right = false;
			const_var.leanRHasDoublelegshow = params.leanR_p_e_l = false;

			params.insulation.rightLean = { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false };
			const_var.isCheckGroundCertificate = false;
		}
		state.params.b_l_t_r_pR = checkType ? "3" : defaultLeanToRoofPitch;
		state.params.b_r_l_t_f = "Open";
		state.params.b_r_l_t_b = "Open";
		state.params.b_r_l_t_r = "Open";
		state.params.b_r_l_t_l = "Open";
		if (action.from !== "changeStyle") {
			state.params.p_b_c_b_r_f = "Open";
			state.params.p_b_c_b_r_b = "Open";
			state.params.p_b_c_b_r = "Open";
			state.params.p_b_c_b_r_r = "Open";
		}

		params.isShowCenter = false;
		const_var.llsh = false;
		const_var.rlsh = false;
		const_var.flsh = false;
		const_var.blsh = false;
		state.params.leanR_p_w = params.leanStyle.right == "gable" ? gableLeanWidthLR : 12;
		state.params.leanR_p_d = params.leanStyle.right == "gable" ? gableLeanLength : state.params.p_d;
		params.leanR_p_h = state.const_var.b_m_i_hlean > params.leanR_p_h ? state.const_var.b_m_i_hlean : params.leanR_p_h;
		const_var.lengthData.rightLean.length = state.params.leanR_p_d;
		params.leantoAlignmentRight = "1";
		UpdateAction = action.event + action.value + state.params.add_right_lean;
		state.isFullyEnclosedCheckedForRightLeanTo = false;
		state.isFullyOpenedCheckedForRightLeanTo = true;

		const_var.checkforLeanto = state.params.add_right_lean == true ? true : false;
		if (state.params.add_right_lean == false) {
			state.params.add_right_front_lean_porch = false;
			state.params.add_right_back_lean_porch = false;
		}

		let straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, state.params.b_l_t_r_pR, const_var.roofRegularDst);

		var calHeight = state.params.leanR_p_h + Math.round((state.params.leanR_p_w * state.params.b_l_t_r_pR) / 12) + straightRoofval;
		let rightLeanRoofHeight = calHeight;

		let isMaxHeight = const_var.roofObject[params.p_b_t][params.p_r_s].max_height;
		if (
			const_var.isForStandardBuilding == true &&
			!const_var.b_o_J_1[params.p_b_t].includes("Free Standing") &&
			!const_var.b_o_J_1[params.p_b_t].includes("RV Covers") &&
			params.p_w <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height
		) {
			isMaxHeight = params.p_w;
		}

		if (state.params.add_right_lean == true && calHeight > state.params.p_h && calHeight <= isMaxHeight) {
			state.params.p_h = params.p_h < rightLeanRoofHeight ? rightLeanRoofHeight : state.params.p_h;
			const_var.UpdatedPriceData.height_price_changed = true;
			const_var.UpdatedPriceData.certificate_price_changed = true;
			const_var.UpdatedPriceData.right_wall_price_changed = true;
			const_var.UpdatedPriceData.left_wall_price_changed = true;
			const_var.UpdatedPriceData.left_wall_cut_panel_price_changed = true;
			const_var.UpdatedPriceData.right_wall_cut_panel_price_changed = true;
			const_var.UpdatedPriceData.front_wall_price_changed = true;
			const_var.UpdatedPriceData.back_wall_price_changed = true;
			const_var.UpdatedPriceData.utility_price_changed = true;
			const_var.UpdatedPriceData.common_height_changed = true;
			const_var.UpdatedPriceData.left_lean_height_price_changed = true;
			const_var.UpdatedPriceData.back_lean_height_price_changed = true;
			const_var.UpdatedPriceData.front_lean_height_price_changed = true;
			if (params.p_f_i) const_var.UpdatedPriceData.insulation_price = undefined;
		}

		cuBuilding.UpdateRightLean();
		makeDimensionUpdateRight(state);
		if (params.p_r_w != "Open" && params.p_r_w != "Close" && chkSideJtrim == true) {
			params.p_j_t = true;
		}
		if (cuComponent.wallnameBySec[params.activeWall] === "rightlean" && !params.add_right_lean) params.activeWall = "c_b_r_w";
	}
	state.params.ShowLeanRecord = params.add_front_lean == true || params.add_back_lean == true || params.add_left_lean == true || params.add_right_lean == true ? true : false;

	state.const_var.ExtraItemsFeaturesArray.map((item) => {
		if (item != null && item != undefined) {
			item.is_edit = false;
			if (
				const_var.UpdatedPriceData["elements"] != undefined &&
				item?.label &&
				const_var.UpdatedPriceData["elements"][item.label.toString()] != undefined &&
				const_var.UpdatedPriceData["elements"][item.label.toString()]?.is_edit != true
			) {
				const_var.UpdatedPriceData["elements"][item.label.toString()].is_edit = false;
			}
		}
	});
	state.const_var.ExtraItemsFeaturesQuantityArray.map((item) => {
		if (item != null && item != undefined) {
			item.is_edit = false;
			if (
				item.name == "bows" &&
				const_var.UpdatedPriceData["elements"] != undefined &&
				item?.label &&
				const_var.UpdatedPriceData["elements"][item.label.toString()] != undefined &&
				const_var.UpdatedPriceData["elements"][item.label.toString()].is_edit == true
			) {
				const_var.UpdatedPriceData["elements"][item.label.toString()].is_edit = false;
			}
			if (
				const_var.UpdatedPriceData["elements"] != undefined &&
				const_var.UpdatedPriceData["elements"][item.label.toString()] != undefined &&
				const_var.UpdatedPriceData["elements"][item.label.toString()].is_edit != true
			) {
				const_var.UpdatedPriceData["elements"][item.label.toString()].is_edit = false;
			}
		}
	});
	if (state.params.p_v_w == true) {
		const_var.b_I_g_n_e = "building-normal.jpg";
		const_var.b_T_t_L_u = "";
	} else {
		const_var.b_I_g_n_e = "imgpsh_fullsizeth.jpeg";
		const_var.b_T_t_L_u = "";
	}
	if (params.p_i_o != 0) {
		const_var.UpdatedPriceData.insulation_price = undefined;
	}

	if (!params.add_front_lean && !params.add_back_lean && !params.add_left_lean && !params.add_right_lean) {
		if (const_var.post_data?.building?.insulation_type != undefined) {
			if (const_var.post_data.building.insulation == "custom" && const_var.post_data.building.insulation_type.insulation_wall != undefined) {
				let checkWallLength = Object.keys(const_var.post_data.building.insulation_type.insulation_wall);
				if (checkWallLength?.length == 0 && const_var.post_data.building.insulation_type.insulation_wall != undefined) {
					params.p_i_o = 0;
					params.p_c_i = false;
					params.p_r_o = false;
					params.p_f_i = false;
				}
			}
		}
	}

	const_var.UpdatedPriceData.bothLeanto = true;
	const_var.UpdatedPriceData.wainscot_price_changed = true;

	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;
	const_var.UpdatedPriceData.certificate_price_changed = true;

	cuBuilding.uBmLDimension();
	dynamicWallOptions(state, action.value);
	dynamicWallOptionsForLeanTo(state);

	cuBuilding.leanuUdD();

	cuBuilding.BuildingUpdate(true, action.value);
	cuComponent.RemovePorchComponent();

	if (const_var.callMesure) {
	}
	const_var.UpdatedPriceData.connection_fee_side_changed = true;
	const_var.UpdatedPriceData.connection_fee_end_changed = true;
	if (params.checkeditName != true) {
		let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
		params.other_building_type_name = newVal;
		if (const_var.post_data.building != undefined) {
			const_var.post_data.building.other_building_type_name = params.other_building_type_name;
			const_var.post_data.building.name = params.other_building_type_name;
		}
	}
	const_var.wallSelection.centerBuildingWall = "c_b_f_w";
	const_var.wallSelection.leanToWall = "select";
	params.activeWall = "c_b_f_w";
	cuComponent.cameraFocusOnWall("c_b_f_w");

	if (state.params.add_left_lean == false && state.params.add_right_lean == false && state.params.add_front_lean == false && state.params.add_back_lean == false) {
		const_var.commonBuildingFlag.wrap = false;
	}

	return {
		...state,
		newColor: UpdateAction
	};
};
export const handleLeanToPorcheSection = (state, action, utils, const_var, params, cuBuilding, cuComponent, dynamicWallOptions, dynamicWallOptionsForLeanTo, updatePorchLengths) => {
	let fullWrapRoofPitch;
	if (action.key === "FullBuilding") {
		if (state.params.add_left_lean == true) fullWrapRoofPitch = state.params.b_l_t_r_p;
		else if (state.params.add_right_lean == true) fullWrapRoofPitch = state.params.b_l_t_r_pR;
		else if (state.params.add_front_lean == true) fullWrapRoofPitch = state.params.b_l_t_r_pF;
		else if (state.params.add_back_lean == true) fullWrapRoofPitch = state.params.b_l_t_r_pB;
		if (fullWrapRoofPitch) state.params.b_l_t_r_p = state.params.b_l_t_r_p = state.params.b_l_t_r_p = state.params.b_l_t_r_p = fullWrapRoofPitch;
	}
	let roofPitch = "2/12";

	const leanToIds = state.const_var.Map_Id[state.params.p_b_t] ?? [];
	let leanToData = const_var.building?.find((data) => data.building_type.building_id === leanToIds);
	if (leanToData != undefined && leanToData.lean_to_roof_pitch != undefined) {
		let roofPitchData = leanToData.lean_to_roof_pitch.find((data) => data.is_default == "yes");
		roofPitch = roofPitchData != undefined ? roofPitchData.roof_pitch : roofPitch;
	}

	let maxLeanToRoofPitch = roofPitch != undefined ? roofPitch.split("/")[0] : 2;
	let tempBuildingName = const_var.defaultBuildingArr[const_var.BuldingIDforReset] && const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name.split(".").includes("Straight_Roof_Barns");

	let assignRoofPitch =
		params.m_s_n == 3 &&
		tempBuildingName &&
		((const_var.editAPIDataByResponse.data?.main_created_at >= "2024-07-01" && (const_var.crmSetting.is_Edit == true || const_var.isKLinkEnable == true)) ||
			const_var.loginSession == false ||
			const_var.loginSession == true)
			? true
			: false;

	if (assignRoofPitch == true) {
		state.params.b_l_t_r_p = "3";
		state.params.b_l_t_r_pR = "3";
		state.params.b_l_t_r_pF = "3";
		state.params.b_l_t_r_pB = "3";
		maxLeanToRoofPitch = "3";
	}
	let maxLeanToHeightArr = [state.params.lean_p_h, state.params.leanF_p_h, state.params.leanB_p_h, state.params.leanR_p_h];
	let maxLeanWidthArr = [state.params.leanF_p_w, state.params.lean_p_w, state.params.leanB_p_w, state.params.leanR_p_w];
	let maxLeanToHeight = Math.max(...maxLeanToHeightArr);
	let maxLeanWidth = Math.max(...maxLeanWidthArr);
	if (state.const_var.b_m_i_hlean > params.lean_p_h && state.const_var.b_m_i_hlean > params.leanF_p_h && state.const_var.b_m_i_hlean > params.leanB_p_h && state.const_var.b_m_i_hlean > params.leanR_p_h) {
		maxLeanToHeight = state.const_var.b_m_i_hlean;
	} else {
		maxLeanToHeight = Math.max(...maxLeanToHeightArr);
	}
	if (action.value == "endLeantoPorchessForTubulerBuildingMnf") {
		const_var.isShowAlert = true;
		const_var.alertUsedFor = "endLeantoPorchessForTubulerBuildingMnf";
		return {
			...state,
			action
		};
	}
	for (const key in params) {
		params.params_cancel[key] = params[key];
	}
	let isHeightChanged = false;
	var chkEndJtrim = false;
	var chkSideJtrim = false;
	if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
		chkEndJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "end").length > 0 ? true : false;
		chkSideJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "side").length > 0 ? true : false;
	}
	let dimensions = const_var.roof_style_Barn;
	if (const_var.roof_style_Barn_with_centerbuilding[params.p_b_t]) {
		dimensions = const_var.roof_style_Barn_with_centerbuilding[params.p_b_t];
	}
	let minWidth = 0;
	dimensions.map((dim) => {
		if (params.p_r_s == dim.roof_id) {
			minWidth = dim.min_width;
		}
	});

	if (action.value == "addLeftFrontLeanToPorch") {
		let preferredRoofPitch;
		if (params.add_left_lean && !params.add_front_lean) preferredRoofPitch = state.params.b_l_t_r_p;
		else if (!params.add_left_lean && params.add_front_lean) preferredRoofPitch = state.params.b_l_t_r_pF;
		else if (params.add_left_lean && params.add_front_lean && state.params.b_l_t_r_p == state.params.b_l_t_r_pF) preferredRoofPitch = state.params.b_l_t_r_p;
		else preferredRoofPitch = maxLeanToRoofPitch;

		let frontLeanToLength = Math.round(params.p_w / 2),
			apiMinLengthNotMatch = false;
		if (action.key != "FullBuilding") {
			state.params.add_left_front_lean_porch = !state.params.add_left_front_lean_porch;
			params.lean_p_h = state.const_var.b_m_i_hlean > params.lean_p_h ? state.const_var.b_m_i_hlean : params.lean_p_h;
		}
		if (action.key != undefined && action.key === "FullBuilding") {
			state.params.leanF_p_w = maxLeanWidth;
			state.params.lean_p_w = maxLeanWidth;
			state.params.leanF_p_d = state.params.p_w;
			state.params.lean_p_d = state.params.p_d;
			state.params.b_l_t_r_pF = fullWrapRoofPitch ? fullWrapRoofPitch : preferredRoofPitch;
			state.params.b_l_t_r_p = fullWrapRoofPitch ? fullWrapRoofPitch : preferredRoofPitch;
			state.params.leanF_p_h = maxLeanToHeight;
			state.params.lean_p_h = maxLeanToHeight;

			if (state.params.add_full_lean_porch == true) {
				state.params.add_left_front_lean_porch = true;
			} else {
				state.params.add_left_front_lean_porch = false;
			}
		} else {
			state.params.add_full_lean_porch = false;
		}

		state.params.ShowLeanRecord = params.add_left_front_lean_porch == true ? true : state.params.ShowLeanRecord;

		if (
			(params.add_left_lean == true && params.add_front_lean == true && params.lean_p_w != params.leanF_p_w) ||
			(params.add_left_lean == true && params.add_front_lean == true && params.b_l_t_r_p != params.b_l_t_r_pF) ||
			(params.add_left_lean == true && params.add_front_lean == true && params.lean_p_h != params.leanF_p_h)
		) {
			state.params.add_left_front_lean_porch = false;
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YouCanNotAddPorch";
		}
		if (state.params.add_left_front_lean_porch == true) {
			params.isShowCenter = false;

			let maxLeanToHeight = Math.max(params.lean_p_h, params.leanF_p_h);

			let straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, params.b_l_t_r_p, const_var.roofRegularDst);

			if (params.p_h < Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval) {
				if (const_var.isForStandardBuilding) {
					if (params.p_w >= Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval) {
						params.p_h = Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval;
						params.lean_p_w = 12;
						params.leanF_p_w = 12;
						isHeightChanged = true;
					}
				} else {
					params.p_h = Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval;
					params.lean_p_w = 12;
					params.leanF_p_w = 12;
					isHeightChanged = true;
				}
			}

			if (state.params.add_front_lean == false) {
				state.params.leanF_p_w = state.params.lean_p_w == 0 ? 12 : params.lean_p_w;
				state.params.leantoAlignmentFront = "2";
				state.params.b_l_t_r_pF = state.params.b_l_t_r_p;
				if (params.p_w / 2 <= minWidth) {
					frontLeanToLength = minWidth;
					apiMinLengthNotMatch = true;
				}

				state.params.leanF_p_d = frontLeanToLength;
				const_var.lengthData.frontLean.length = state.params.leanF_p_d;
				params.leanF_p_h = params.lean_p_h;
			}

			if (state.params.add_left_lean == false) {
				state.params.lean_p_d = Math.round(params.p_d / 2);
				state.params.leantoAlignmentLeft = "2";
				state.params.b_l_t_r_p = state.params.b_l_t_r_pF;

				state.params.lean_p_w = state.params.leanF_p_w == 0 ? 12 : params.leanF_p_w;
				const_var.lengthData.leftLean.length = state.params.lean_p_d;
				state.params.lean_p_h = state.params.leanF_p_h;
			}

			if (
				(params.add_left_lean == true && params.add_front_lean == true && state.params.leanF_p_w != state.params.lean_p_w) ||
				(params.add_left_lean == true && params.add_front_lean == true && state.params.b_l_t_r_pF != state.params.b_l_t_r_p) ||
				(params.add_left_lean == true && params.add_front_lean == true && params.lean_p_h != params.leanF_p_h) ||
				(state.params.add_right_front_lean_porch != true && state.params.leantoAlignmentFront != "2" && params.p_w != params.leanF_p_d) ||
				(params.leantoAlignmentLeft != "2" && params.lean_p_d != params.p_d && params.add_left_back_lean_porch == false)
			) {
				state.params.add_left_front_lean_porch = false;
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotAddPorch";
			}

			if (state.params.add_right_front_lean_porch == true) {
				state.params.add_front_lean = state.params.add_right_front_lean_porch;
				state.params.leantoAlignmentFront = "3";
				state.params.leanF_p_w = state.params.leanR_p_w;
			}

			if (
				state.params.leanF_p_w == state.params.lean_p_w &&
				params.leanF_p_h == params.lean_p_h &&
				(state.params.leanF_p_d == Math.round(params.p_w / 2) || apiMinLengthNotMatch) &&
				state.params.leantoAlignmentFront == "2" &&
				state.params.b_l_t_r_pF == state.params.b_l_t_r_p
			) {
				state.params.add_front_lean = state.params.add_left_front_lean_porch;
			}

			if (state.params.lean_p_d == Math.round(params.p_d / 2) && state.params.leantoAlignmentLeft == "2") {
				state.params.add_left_lean = state.params.add_left_front_lean_porch;
			}

			if (
				(state.params.add_right_front_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) ||
				(state.params.add_right_front_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR)
			) {
				state.params.add_left_front_lean_porch = false;
			}

			if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
				state.params.leanF_p_d = state.params.p_w;
			}

			if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
				state.params.lean_p_d = state.params.p_d;
			}

			if (state.params.add_front_lean == false) {
				state.params.leanF_p_d = state.params.p_w;
				state.params.leantoAlignmentFront = "1";
				state.params.b_l_t_r_pF = "2";
				state.params.leanF_p_w = state.params.leanF_p_w;
				params.leanF_p_h = params.lean_p_h;
				state.params.p_b_c_b_f_l = "Open";
				state.params.p_b_c_b_f_b = "Open";
				state.params.p_b_c_b_f_f = "Open";
				state.params.b_f_l_t_f = "Open";
				state.params.b_f_l_t_l = "Open";
				state.params.b_f_l_t_r = "Open";
			}

			if (state.params.add_left_lean == false) {
				state.params.leantoAlignmentLeft = "1";

				state.params.lean_p_w = state.params.lean_p_w;

				state.params.p_b_c_b_l_f = "Open";
				state.params.p_b_c_b_l_b = "Open";
				state.params.p_b_c_b_l = "Open";
				state.params.b_l_l_t_l = "Open";
				state.params.b_l_l_t_r = "Open";
				state.params.b_l_l_t_b = "Open";
				state.params.b_l_l_t_f = "Open";
			}
			if (params.leanF_p_d == params.p_w && !apiMinLengthNotMatch) {
				params.leantoAlignmentFront = "1";
			}
			if (params.lean_p_d == params.p_d) {
				params.leantoAlignmentLeft = "1";
			}
		}
		const_var.UpdatedPriceData.left_front_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		cuBuilding.UpdateLeftLean();
		cuBuilding.UpdateFrontLean();
		makeDimensionUpdateLeft(state);
		makeDimensionUpdateFront(state);
	}
	if (action.value == "addRightFrontLeanToPorch") {
		let preferredRoofPitch;
		if (params.add_right_lean && !params.add_front_lean) preferredRoofPitch = state.params.b_l_t_r_pR;
		else if (!params.add_right_lean && params.add_front_lean) preferredRoofPitch = state.params.b_l_t_r_pF;
		else if (params.add_right_lean && params.add_front_lean && state.params.b_l_t_r_pR == state.params.b_l_t_r_pF) preferredRoofPitch = state.params.b_l_t_r_pR;
		else preferredRoofPitch = maxLeanToRoofPitch;

		let frontLeanToLength = Math.round(params.p_w / 2),
			apiMinLengthNotMatch = false;
		if (action.key != "FullBuilding") {
			state.params.add_right_front_lean_porch = !state.params.add_right_front_lean_porch;
			params.leanR_p_h = state.const_var.b_m_i_hlean > params.leanR_p_h ? state.const_var.b_m_i_hlean : params.leanR_p_h;
		}
		if (action.key != undefined && action.key === "FullBuilding") {
			state.params.leanF_p_w = maxLeanWidth;
			state.params.leanR_p_w = maxLeanWidth;
			state.params.leanB_p_d = state.params.p_w;
			state.params.leanR_p_d = state.params.p_d;
			state.params.b_l_t_r_pF = fullWrapRoofPitch ? fullWrapRoofPitch : preferredRoofPitch;
			state.params.b_l_t_r_pR = fullWrapRoofPitch ? fullWrapRoofPitch : preferredRoofPitch;
			state.params.leanF_p_h = maxLeanToHeight;
			state.params.leanR_p_h = maxLeanToHeight;

			if (state.params.add_full_lean_porch == true) {
				state.params.add_right_front_lean_porch = true;
			} else {
				state.params.add_right_front_lean_porch = false;
			}
		} else {
			state.params.add_full_lean_porch = false;
		}

		state.params.ShowLeanRecord = params.add_right_front_lean_porch == true ? true : state.params.ShowLeanRecord;

		if (
			(params.add_right_lean == true && params.add_front_lean == true && params.leanR_p_w != params.leanF_p_w) ||
			(params.add_right_lean == true && params.add_front_lean == true && params.b_l_t_r_pR != params.b_l_t_r_pF) ||
			(params.add_right_lean == true && params.add_front_lean == true && params.leanR_p_h != params.leanF_p_h)
		) {
			state.params.add_right_front_lean_porch = false;
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YouCanNotAddPorch";
		}

		if (state.params.add_right_front_lean_porch == true) {
			params.isShowCenter = false;

			let maxLeanToHeight = Math.max(params.leanR_p_h, params.leanF_p_h);

			let straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, params.b_l_t_r_pR, const_var.roofRegularDst);

			if (params.p_h < Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval) {
				if (const_var.isForStandardBuilding) {
					if (params.p_w >= Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval) {
						params.p_h = Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval;
						params.leanR_p_w = 12;
						params.leanF_p_w = 12;
						isHeightChanged = true;
					}
				} else {
					params.p_h = Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval;
					params.leanR_p_w = 12;
					params.leanF_p_w = 12;
					isHeightChanged = true;
				}
			}

			if (state.params.add_front_lean == false) {
				state.params.leanF_p_w = state.params.leanR_p_w == 0 ? 12 : state.params.leanR_p_w;

				state.params.leantoAlignmentFront = "3";
				state.params.b_l_t_r_pF = state.params.b_l_t_r_pR;
				params.leanF_p_h = params.leanR_p_h;

				if (params.p_w / 2 <= minWidth) {
					frontLeanToLength = minWidth;
					apiMinLengthNotMatch = true;
				}
				state.params.leanF_p_d = frontLeanToLength;
				const_var.lengthData.frontLean.length = state.params.leanF_p_d;
			}

			if (state.params.add_right_lean == false) {
				state.params.leanR_p_d = Math.round(params.p_d / 2);
				const_var.lengthData.rightLean.length = state.params.leanR_p_d;
				state.params.leantoAlignmentRight = "2";
				state.params.b_l_t_r_pR = state.params.b_l_t_r_pF;
				params.leanR_p_h = params.leanF_p_h;
				state.params.leanR_p_w = state.params.leanF_p_w == 0 ? 12 : state.params.leanF_p_w;
			}

			if (
				(params.add_right_lean == true && params.add_front_lean == true && state.params.leanF_p_w != state.params.leanR_p_w) ||
				(params.add_right_lean == true && params.add_front_lean == true && state.params.b_l_t_r_pF != state.params.b_l_t_r_pR) ||
				(params.add_right_lean == true && params.add_front_lean == true && params.leanR_p_h != params.leanF_p_h) ||
				(state.params.add_left_front_lean_porch != true && state.params.leantoAlignmentFront != "3" && params.p_w != params.leanF_p_d) ||
				(params.leantoAlignmentRight != "2" && params.leanR_p_d != params.p_d && params.add_right_back_lean_porch == false)
			) {
				state.params.add_right_front_lean_porch = false;
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotAddPorch";
			}

			if (state.params.add_left_front_lean_porch == true) {
				state.params.add_front_lean = state.params.add_left_front_lean_porch;
				state.params.leantoAlignmentFront = "2";
				state.params.leanF_p_w = state.params.lean_p_w;
			}

			if (
				state.params.leanF_p_w == state.params.leanR_p_w &&
				params.leanF_p_h == params.leanR_p_h &&
				(state.params.leanF_p_d == Math.round(params.p_w / 2) || apiMinLengthNotMatch) &&
				state.params.leantoAlignmentFront == "3" &&
				state.params.b_l_t_r_pF == state.params.b_l_t_r_pR
			) {
				state.params.add_front_lean = state.params.add_right_front_lean_porch;
			}

			if (state.params.leanR_p_d == Math.round(params.p_d / 2) && state.params.leantoAlignmentRight == "2") {
				state.params.add_right_lean = state.params.add_right_front_lean_porch;
			}

			if (
				(state.params.add_left_front_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) ||
				(state.params.add_left_front_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR)
			) {
				state.params.add_right_front_lean_porch = false;
			}

			if (state.params.add_left_front_lean_porch == true && state.params.add_right_front_lean_porch == true) {
				state.params.leanF_p_d = state.params.p_w;
			}

			if (state.params.add_right_back_lean_porch == true && state.params.add_right_front_lean_porch == true) {
				state.params.leanR_p_d = state.params.p_d;
			}

			if (state.params.add_front_lean == false) {
				state.params.leanF_p_d = state.params.p_w;
				state.params.leantoAlignmentFront = "1";

				state.params.b_l_t_r_pF = "2";
				state.params.leanF_p_w = state.params.leanF_p_w;

				state.params.p_b_c_b_f_l = "Open";
				state.params.p_b_c_b_f_b = "Open";
				state.params.p_b_c_b_f_f = "Open";
				state.params.b_f_l_t_f = "Open";
				state.params.b_f_l_t_l = "Open";
				state.params.b_f_l_t_r = "Open";
			}

			if (state.params.add_right_lean == false) {
				state.params.leantoAlignmentRight = "1";

				state.params.leanR_p_w = state.params.lean_p_w;

				state.params.p_b_c_b_r_f = "Open";
				state.params.p_b_c_b_r_b = "Open";
				state.params.p_b_c_b_r = "Open";
				state.params.b_r_l_t_r = "Open";
				state.params.b_r_l_t_b = "Open";
				state.params.b_r_l_t_f = "Open";
				state.params.b_r_l_t_l = "Open";
			}
			if (params.leanF_p_d == params.p_w && !apiMinLengthNotMatch) {
				params.leantoAlignmentFront = "1";
			}
			if (params.leanR_p_d == params.p_d) {
				params.leantoAlignmentRight = "1";
			}
		}
		const_var.UpdatedPriceData.right_front_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.front_wall_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		cuBuilding.UpdateFrontLean();
		cuBuilding.UpdateRightLean();
		makeDimensionUpdateRight(state);
		makeDimensionUpdateFront(state);
	}
	if (action.value == "addRightBackLeanToPorch") {
		let preferredRoofPitch;
		if (params.add_right_lean && !params.add_back_lean) preferredRoofPitch = state.params.b_l_t_r_pR;
		else if (!params.add_right_lean && params.add_back_lean) preferredRoofPitch = state.params.b_l_t_r_pB;
		else if (params.add_right_lean && params.add_back_lean && state.params.b_l_t_r_pR == state.params.b_l_t_r_pB) preferredRoofPitch = state.params.b_l_t_r_pR;
		else preferredRoofPitch = maxLeanToRoofPitch;

		let backLeanToLength = Math.round(params.p_w / 2),
			apiMinLengthNotMatch = false;
		if (action.key != "FullBuilding") {
			state.params.add_right_back_lean_porch = !state.params.add_right_back_lean_porch;
			params.leanR_p_h = state.const_var.b_m_i_hlean > params.leanR_p_h ? state.const_var.b_m_i_hlean : params.leanR_p_h;
		}
		if (action.key != undefined && action.key === "FullBuilding") {
			state.params.leanB_p_w = maxLeanWidth;
			state.params.leanR_p_w = maxLeanWidth;
			state.params.leanB_p_d = state.params.p_w;
			state.params.leanR_p_d = state.params.p_d;
			state.params.b_l_t_r_pB = fullWrapRoofPitch ? fullWrapRoofPitch : preferredRoofPitch;
			state.params.b_l_t_r_pR = fullWrapRoofPitch ? fullWrapRoofPitch : preferredRoofPitch;
			state.params.leanB_p_h = maxLeanToHeight;
			state.params.leanR_p_h = maxLeanToHeight;

			if (state.params.add_full_lean_porch == true) {
				state.params.add_right_back_lean_porch = true;
			} else {
				state.params.add_right_back_lean_porch = false;
			}
		} else {
			state.params.add_full_lean_porch = false;
		}

		state.params.ShowLeanRecord = params.add_right_back_lean_porch == true ? true : state.params.ShowLeanRecord;

		if (
			(params.add_right_lean == true && params.add_back_lean == true && params.leanR_p_w != params.leanB_p_w) ||
			(params.add_right_lean == true && params.add_back_lean == true && params.b_l_t_r_pR != params.b_l_t_r_pB) ||
			(params.add_right_lean == true && params.add_back_lean == true && params.leanR_p_h != params.leanB_p_h)
		) {
			state.params.add_right_back_lean_porch = false;
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YouCanNotAddPorch";
		}

		if (state.params.add_right_back_lean_porch == true) {
			params.isShowCenter = false;

			let maxLeanToHeight = Math.max(params.leanR_p_h, params.leanB_p_h);

			let straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, params.b_l_t_r_pR, const_var.roofRegularDst);

			if (params.p_h < Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval) {
				if (const_var.isForStandardBuilding) {
					if (params.p_w >= Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval) {
						params.p_h = Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval;
						params.leanR_p_w = 12;
						params.leanB_p_w = 12;
						isHeightChanged = true;
					}
				} else {
					params.p_h = Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval;
					params.leanR_p_w = 12;
					params.leanB_p_w = 12;
					isHeightChanged = true;
				}
			}

			if (state.params.add_back_lean == false) {
				state.params.leanB_p_w = state.params.leanR_p_w == 0 ? 12 : state.params.leanR_p_w;
				state.params.leantoAlignmentBack = "2";
				state.params.b_l_t_r_pB = state.params.b_l_t_r_pR;
				params.leanB_p_h = params.leanR_p_h;

				if (params.p_w / 2 <= minWidth) {
					backLeanToLength = minWidth;
					apiMinLengthNotMatch = true;
				}
				state.params.leanB_p_d = backLeanToLength;
				const_var.lengthData.backLean.length = state.params.leanB_p_d;
			}

			if (state.params.add_right_lean == false) {
				state.params.leanR_p_d = Math.round(params.p_d / 2);
				const_var.lengthData.rightLean.length = state.params.leanR_p_d;
				state.params.leantoAlignmentRight = "3";
				state.params.b_l_t_r_pR = state.params.b_l_t_r_pB;
				params.leanR_p_h = params.leanB_p_h;
				state.params.leanR_p_w = state.params.leanB_p_w == 0 ? 12 : state.params.leanB_p_w;
			}
			if (
				(params.add_right_lean == true && params.add_back_lean == true && state.params.leanB_p_w != state.params.leanR_p_w) ||
				(params.add_right_lean == true && params.add_back_lean == true && state.params.b_l_t_r_pB != state.params.b_l_t_r_pR) ||
				(params.add_right_lean == true && params.add_back_lean == true && params.leanR_p_h != params.leanB_p_h) ||
				(state.params.add_left_back_lean_porch != true && state.params.leantoAlignmentBack != "2" && params.p_w != params.leanB_p_d) ||
				(state.params.leantoAlignmentRight != "3" && params.leanR_p_d != params.p_d && params.add_right_front_lean_porch == false)
			) {
				state.params.add_right_back_lean_porch = false;
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotAddPorch";
			}

			if (state.params.add_left_back_lean_porch == true) {
				state.params.add_back_lean = state.params.add_left_back_lean_porch;
				state.params.leantoAlignmentBack = "3";
				state.params.leanB_p_w = state.params.leanR_p_w;
			}

			if (
				state.params.leanB_p_w == state.params.leanR_p_w &&
				params.leanB_p_h == params.leanR_p_h &&
				(state.params.leanB_p_d == Math.round(params.p_w / 2) || apiMinLengthNotMatch) &&
				state.params.leantoAlignmentBack == "2" &&
				state.params.b_l_t_r_pB == state.params.b_l_t_r_pR
			) {
				state.params.add_back_lean = state.params.add_right_back_lean_porch;
			}

			if (state.params.leanR_p_d == Math.round(params.p_d / 2) && state.params.leantoAlignmentRight == "3") {
				state.params.add_right_lean = state.params.add_right_back_lean_porch;
			}

			if (
				(state.params.add_left_back_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) ||
				(state.params.add_left_back_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR)
			) {
				state.params.add_right_back_lean_porch = false;
			}

			if (state.params.add_left_back_lean_porch == true && state.params.add_right_back_lean_porch == true) {
				state.params.leanB_p_d = state.params.p_w;
			}

			if (state.params.add_right_back_lean_porch == true && state.params.add_right_front_lean_porch == true) {
				state.params.leanR_p_d = state.params.p_d;
			}

			if (state.params.add_back_lean == false) {
				state.params.leanB_p_d = state.params.p_w;
				state.params.leantoAlignmentBack = "1";
				state.params.b_l_t_r_pB = "2";
				state.params.leanB_p_w = state.params.leanB_p_w;

				state.params.p_b_c_b_b_l = "Open";
				state.params.p_b_c_b_b_f = "Open";
				state.params.p_b_c_b_b_b = "Open";
				state.params.b_b_l_t_f = "Open";
				state.params.b_b_l_t_l = "Open";
				state.params.b_b_l_t_r = "Open";
			}
			if (state.params.add_right_lean == false) {
				state.params.leantoAlignmentRight = "1";

				state.params.leanR_p_w = state.params.lean_p_w;
				state.params.p_b_c_b_r_f = "Open";
				state.params.p_b_c_b_r_b = "Open";
				state.params.p_b_c_b_r = "Open";
				state.params.b_r_l_t_r = "Open";
				state.params.b_r_l_t_b = "Open";
				state.params.b_r_l_t_f = "Open";
				state.params.b_r_l_t_l = "Open";
			}
			if (params.leanB_p_d == params.p_w && !apiMinLengthNotMatch) {
				params.leantoAlignmentBack = "1";
			}
			if (params.leanR_p_d == params.p_d) {
				params.leantoAlignmentRight = "1";
			}
		}
		const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.right_wall_price_changed = true;
		cuBuilding.UpdateRightLean();
		cuBuilding.UpdateBackLean();
		makeDimensionUpdateRight(state);
		makeDimensionUpdateBack(state);
	}
	if (action.value == "addLeftBackLeanToPorch") {
		let preferredRoofPitch;
		if (params.add_left_lean && !params.add_back_lean) preferredRoofPitch = state.params.b_l_t_r_p;
		else if (!params.add_left_lean && params.add_back_lean) preferredRoofPitch = state.params.b_l_t_r_pB;
		else if (params.add_left_lean && params.add_back_lean && state.params.b_l_t_r_p == state.params.b_l_t_r_pB) preferredRoofPitch = state.params.b_l_t_r_p;
		else preferredRoofPitch = maxLeanToRoofPitch;

		let backLeanToLength = Math.round(params.p_w / 2),
			apiMinLengthNotMatch = false;
		if (action.key != "FullBuilding") {
			state.params.add_left_back_lean_porch = !state.params.add_left_back_lean_porch;
			params.lean_p_h = state.const_var.b_m_i_hlean > params.lean_p_h ? state.const_var.b_m_i_hlean : params.lean_p_h;
		}
		if (action.key != undefined && action.key === "FullBuilding") {
			state.params.leanB_p_w = maxLeanWidth;
			state.params.lean_p_w = maxLeanWidth;
			state.params.leanB_p_d = state.params.p_w;
			state.params.lean_p_d = state.params.p_d;
			state.params.b_l_t_r_pB = fullWrapRoofPitch ? fullWrapRoofPitch : preferredRoofPitch;
			state.params.b_l_t_r_p = fullWrapRoofPitch ? fullWrapRoofPitch : preferredRoofPitch;
			state.params.leanB_p_h = maxLeanToHeight;
			state.params.lean_p_h = maxLeanToHeight;

			if (state.params.add_full_lean_porch == true) {
				state.params.add_left_back_lean_porch = true;
			} else {
				state.params.add_left_back_lean_porch = false;
			}
		} else {
			state.params.add_full_lean_porch = false;
		}

		state.params.ShowLeanRecord = params.add_left_back_lean_porch == true ? true : state.params.ShowLeanRecord;

		if (
			(params.add_left_lean == true && params.add_back_lean == true && params.lean_p_w != params.leanB_p_w) ||
			(params.add_left_lean == true && params.add_back_lean == true && params.b_l_t_r_p != params.b_l_t_r_pB) ||
			(params.add_left_lean == true && params.add_back_lean == true && params.lean_p_h != params.leanB_p_h)
		) {
			state.params.add_left_back_lean_porch = false;
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = "YouCanNotAddPorch";
		}

		if (state.params.add_left_back_lean_porch == true) {
			params.isShowCenter = false;

			let straightRoofval = utils.straightRoofDistance(params.p_r_s, params.p_r_p, params.b_l_t_r_p, const_var.roofRegularDst);

			if (params.p_h < Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval) {
				if (const_var.isForStandardBuilding) {
					if (params.p_w >= Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval) {
						params.p_h = Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval;
						params.lean_p_w = 12;
						params.leanB_p_w = 12;
						isHeightChanged = true;
					}
				} else {
					params.p_h = Math.round(maxLeanToHeight + (preferredRoofPitch / 12) * 12) + straightRoofval;
					params.lean_p_w = 12;
					params.leanB_p_w = 12;
					isHeightChanged = true;
				}
			}

			if (state.params.add_back_lean == false) {
				if (params.p_w / 2 <= minWidth) {
					backLeanToLength = minWidth;
					apiMinLengthNotMatch = true;
				}
				state.params.leanB_p_d = backLeanToLength;
				const_var.lengthData.backLean.length = state.params.leanB_p_d;
				state.params.leanB_p_w = state.params.lean_p_w == 0 ? 12 : state.params.lean_p_w;
				state.params.leantoAlignmentBack = "3";
				state.params.b_l_t_r_pB = state.params.b_l_t_r_p;
				params.leanB_p_h = params.lean_p_h;
			}

			if (state.params.add_left_lean == false) {
				state.params.lean_p_d = Math.round(params.p_d / 2);
				const_var.lengthData.leftLean.length = state.params.lean_p_d;
				state.params.leantoAlignmentLeft = "3";
				state.params.lean_p_w = state.params.leanB_p_w == 0 ? 12 : state.params.leanB_p_w;
				state.params.b_l_t_r_p = state.params.b_l_t_r_pB;
				params.lean_p_h = params.leanB_p_h;
			}

			if (
				(params.add_left_lean == true && params.add_back_lean == true && state.params.leanB_p_w != state.params.lean_p_w) ||
				(params.add_left_lean == true && params.add_back_lean == true && state.params.b_l_t_r_pB != state.params.b_l_t_r_p) ||
				(params.add_left_lean == true && params.add_back_lean == true && params.lean_p_h != params.leanB_p_h) ||
				(state.params.add_right_back_lean_porch != true && state.params.leantoAlignmentBack != "3" && params.p_w != params.leanB_p_d) ||
				(state.params.leantoAlignmentLeft != "3" && params.lean_p_d != params.p_d && params.add_left_front_lean_porch == false)
			) {
				state.params.add_left_back_lean_porch = false;
				state.const_var.isShowAlert = true;
				state.const_var.alertUsedFor = "YouCanNotAddPorch";
			}

			if (state.params.add_right_back_lean_porch == true) {
				state.params.add_back_lean = state.params.add_right_back_lean_porch;
				state.params.leantoAlignmentBack = "2";
				state.params.leanB_p_w = state.params.lean_p_w;
			}

			if (
				state.params.leanB_p_w == state.params.lean_p_w &&
				params.leanB_p_h == params.lean_p_h &&
				(state.params.leanB_p_d == Math.round(params.p_w / 2) || apiMinLengthNotMatch) &&
				state.params.leantoAlignmentBack == "3" &&
				state.params.b_l_t_r_pB == state.params.b_l_t_r_p
			) {
				state.params.add_back_lean = state.params.add_left_back_lean_porch;
			}

			if (state.params.lean_p_d == Math.round(params.p_d / 2) && state.params.leantoAlignmentLeft == "3") {
				state.params.add_left_lean = state.params.add_left_back_lean_porch;
			}

			if (
				(state.params.add_right_back_lean_porch == true && state.params.lean_p_w != state.params.leanR_p_w) ||
				(state.params.add_right_back_lean_porch == true && state.params.b_l_t_r_p != state.params.b_l_t_r_pR)
			) {
				state.params.add_left_back_lean_porch = false;
			}

			if (state.params.add_left_back_lean_porch == true && state.params.add_right_back_lean_porch == true) {
				state.params.leanB_p_d = state.params.p_w;
			}

			if (state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
				state.params.lean_p_d = state.params.p_d;
			}

			if (state.params.add_back_lean == false) {
				state.params.leanB_p_d = state.params.p_w;
				state.params.leantoAlignmentBack = "1";
				state.params.leanB_p_w = state.params.leanB_p_w;
				state.params.b_l_t_r_pB = "2";

				state.params.p_b_c_b_b_l = "Open";
				state.params.p_b_c_b_b_f = "Open";
				state.params.p_b_c_b_b_b = "Open";
				state.params.b_b_l_t_f = "Open";
				state.params.b_b_l_t_l = "Open";
				state.params.b_b_l_t_r = "Open";
			}

			if (state.params.add_left_lean == false) {
				state.params.leantoAlignmentLeft = "1";

				state.params.lean_p_w = state.params.lean_p_w;

				state.params.p_b_c_b_l_f = "Open";
				state.params.p_b_c_b_l_b = "Open";
				state.params.p_b_c_b_l = "Open";
				state.params.b_l_l_t_l = "Open";
				state.params.b_l_l_t_r = "Open";
				state.params.b_l_l_t_b = "Open";
				state.params.b_l_l_t_f = "Open";
			}
			if (params.leanB_p_d == params.p_w && !apiMinLengthNotMatch) {
				params.leantoAlignmentBack = "1";
			}
			if (params.lean_p_d == params.p_d) {
				params.leantoAlignmentLeft = "1";
			}
		}

		const_var.UpdatedPriceData.right_back_wrap_connection_fee_changed = true;
		const_var.UpdatedPriceData.back_wall_price_changed = true;
		const_var.UpdatedPriceData.left_wall_price_changed = true;
		cuBuilding.UpdateLeftLean();
		cuBuilding.UpdateBackLean();
		makeDimensionUpdateLeft(state);
		makeDimensionUpdateBack(state);
	}
	if (state.params.add_right_front_lean_porch == true && state.params.add_right_back_lean_porch == true && state.params.add_left_front_lean_porch == true && state.params.add_left_back_lean_porch == true) {
		state.params.add_full_lean_porch = true;
	}
	updatePorchLengths();
	cuComponent.RemovePorchComponent();
	const_var.UpdatedPriceData.bothLeanto = true;
	cuBuilding.uBmLDimension();
	dynamicWallOptions(state);
	dynamicWallOptionsForLeanTo(state);
	cuBuilding.leanuUdD();
	cuBuilding.BuildingUpdate();
	// cuBuilding.uUdDp();
	if (isHeightChanged && params.cupola) handlCupolaPositionOnDimensionChange("h");
	if (params.p_r_w != "Open" && params.p_r_w != "Close" && chkSideJtrim == true) {
		params.p_j_t = true;
	}
	if (params.p_l_w != "Open" && params.p_l_w != "Close" && chkSideJtrim == true) {
		params.p_j_t = true;
	}
	if (params.p_b_w != "Open" && params.p_b_w != "Close" && chkEndJtrim == true) {
		params.p_j_t_end = true;
	}
	if (params.p_f_w != "Open" && params.p_f_w != "Close" && chkEndJtrim == true) {
		params.p_j_t_end = true;
	}

	const_var.UpdatedPriceData.connection_fee_side_changed = true;
	const_var.UpdatedPriceData.wainscot_price_changed = true;

	const_var.UpdatedPriceData.roof_color_price_changed = true;
	const_var.UpdatedPriceData.wall_color_price_changed = true;
	const_var.UpdatedPriceData.trim_color_price_changed = true;
	if (params.checkeditName != true) {
		let newVal = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
		params.other_building_type_name = newVal;
		if (const_var.post_data.building != undefined) {
			const_var.post_data.building.other_building_type_name = params.other_building_type_name;
			const_var.post_data.building.name = params.other_building_type_name;
		}
	}
	const_var.UpdatedPriceData.height_price_changed = true;
	return {
		...state,
		action
	};
};
export const handleLeanUtility = ({
	checkFlag,
	storageKey,
	positionKey,
	depthKey,
	sideCloseKey1,
	sideCloseKey2,
	wallKey,
	leanStyleKey,
	leanData,
	updatedFlagKey,
	positionConditionType,
	data,
	b,
	t_c_b,
	UpdatePriceRecord,
	params,
	const_var
}) => {
	if (params[checkFlag] === true && data.utility_side.length > 0) {
		let sideValue = 0;
		let endValue = 1;

		// Side close logic
		if (params[sideCloseKey1] != "Close") sideValue++;
		if (const_var.isLTBuilding && params[sideCloseKey2] != "Close") sideValue++;

		b.utility_position = params[positionKey];

		const isValidPosition = positionConditionType === "gt" ? b.utility_position > 0 : b.utility_position != 0;

		if (isValidPosition && parseFloat(b.utility_position) + parseFloat(params[storageKey]) != params[depthKey]) {
			endValue = 2;
		}

		if (params[wallKey] != "Close" && params.leanStyle[leanStyleKey] !== "gable") {
			sideValue++;
		}

		const calculatedPrice =
			params.p_v_w == true
				? data.utility_side[0].vertical_side_cost * sideValue + data.end[0].vertical_ends_cost * endValue + data.utility_side[0].side_close_cost * sideValue + data.end[0].end_close_cost * endValue
				: data.utility_side[0].side_close_cost * sideValue + data.end[0].end_close_cost * endValue;

		b.utility_price = UpdatePriceRecord == true && const_var.UpdatedPriceData[updatedFlagKey] != true ? leanData.utility_price : calculatedPrice.toFixed(2);

		t_c_b = parseFloat(t_c_b) + parseFloat(b.utility_price);

		b.utility_length = params[storageKey];
		b.has_utility = true;
		b.utility_vertical = params.p_v_w ? true : false;

		b.utility_on_centers = const_var.DistanceArr?.[params.p_b_t]?.[params.p_r_s] == undefined ? 5 : const_var.DistanceArr[params.p_b_t][params.p_r_s];

		return {
			t_c_b,
			CalCulateRoofUtilityEndPrice: parseFloat(b.utility_price)
		};
	}

	return { t_c_b, CalCulateRoofUtilityEndPrice: 0 };
};
